<script type="text/javascript">
	import moment from "moment";
	import { onMount, onDestroy } from "svelte";
	import { get, writable } from "svelte/store";

	import Datepicker from "svelte-calendar";
	import Radio from '@smui/radio';
	import FormField from '@smui/form-field';
	import Textfield, {Input, Textarea} from "@smui/textfield";
	import HelperText from "@smui/textfield/helper-text/index";
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Button, {Label} from '@smui/button';
	import Card from '@smui/card';
	import TextfieldWithButton from "../../UI/TextfieldWithButton/TextfieldWithButton.svelte";

	import MenuItem from "../../UI/FlyoutMenu/MenuItem.svelte";
	import Icon from "../../UI/Icons/Icon";

	import '../../UI/LayerList/LayerList.scss';
	import LayerListSwitch from '../../UI/LayerList/LayerListSwitch.svelte';

	import MapStore from "../../Map/Store";
	import MapLayerManager from "../../Map/MapLayerManager";
	import MapDataSource from "../../Map/Enums/MapDataSource";
	import InfoCardStore from "../../UI/InfoCard/Store";

	import TimeSlider from "../../UI/TimeSlider/TimeSlider.svelte";
	import DirectionalArrow from "../../UI/DirectionalArrow.svelte";

	import DownloadButton from "../../UI/DownloadButton/DownloadButton.svelte";
	import DownloadHelper from "../../Helpers/DownloadHelper";

	import IdentityHelper from "../../Branding/IdentityHelper";
	import User from "../../Branding/User";
	import Feature from "../../Branding/Feature";

	import GeoHelper from "../../Helpers/GeoHelper";
	import StringHelper from "../../Helpers/StringHelper";
	import FilterHelper from "../../Helpers/FilterHelper";
	import roundFloat from "../../Helpers/Misc/roundFloat";
	import { getOneYearAgo, getTwoYearsAgo } from "../../Helpers/Misc/timeHelper";

	import LoadState from "../../Enums/LoadState";
	import DateDialect from "../../Enums/DateDialect";
	import DownsampleRate from "../../Enums/DownsampleRate";
	import DataFormat from "../../Enums/DataFormat";
	import LoadingStore from "../../LoadingStore";

	import Router from "../../Router";

	import AuthStore from "../../Auth/Store";
	import AuthState from "../../Auth/Enums/AuthState";

	import VideoSatStore from "./Store";

	let footprints = VideoSatStore.results.footprints;

	onMount(() => {
		VideoSatStore.actions.init();
	});

</script>

<MenuItem title={"Videos"} materialIcon={"query_builder"}>

</MenuItem>
